<template>
  <!--
      	作者：gmshop
      	时间：2020-06-25
      	描述：插件中心-限时拼团-活动列表-添加活动
      -->
  <div>
    <div class="product-content">
      <el-form size="small" ref="form"  :model="form" label-width="150px">
        <el-form-item label="奖项文案" :rules="[{required: true,message: ' '}]" prop="title">
          <el-input v-model="form.title" placeholder="奖项文案" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="中奖概率" :rules="[{required: true,message: ' '}]" prop="weight">
          <el-input v-model="form.weight" placeholder="中奖概率" class="max-w460"></el-input>
          <div class="tips">中奖概率，数值越大中奖概率越高，数值一样时随机中奖</div>
        </el-form-item>
        <el-form-item label="是否开启积分奖励" prop="is_point">
          <el-checkbox v-model="form.is_point">是否开启积分奖励</el-checkbox>
          <div class="tips"></div>
        </el-form-item>
        <el-form-item label="积分设置"  v-if="form.is_point">
          <el-input v-model="form.point" placeholder="积分设置" type="number" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="是否开启礼品奖励" prop="is_product">
          <el-checkbox v-model="form.is_product">是否开启礼品奖励</el-checkbox>
          <div class="tips"></div>
        </el-form-item>
        <el-form-item label="礼品设置"  v-if="form.is_product">
          <el-input v-model="form.product_id" placeholder="礼品设置" type="number" class="max-w460"></el-input>
          <el-button type="primary" @click="addRewardProduct()">选择礼品</el-button>
        </el-form-item>
        <el-form-item label="礼品数量设置"  v-if="form.is_product">
          <el-input v-model="form.product_num" placeholder="礼品数量设置" type="number" class="max-w460"></el-input>
        </el-form-item>
        <!-- <el-form-item label="是否图片" prop="is_image">
          <el-checkbox v-model="form.is_image">是否图片</el-checkbox>
          <div class="tips"></div>
        </el-form-item> -->

        <el-form-item label="奖项图片">

          <el-row>
            <el-button icon="el-icon-picture-outline" @click="openUpload('image')">选择图片</el-button>
            <div v-if="form.image_id!=''" class="img">
              <img :src="form.file_path" width="100" height="100" />
            </div>
          </el-row>

        </el-form-item>
        <el-form-item label="抽中展示图片">
          <el-row>
            <el-button icon="el-icon-picture-outline" @click="openUpload('cover')">选择图片</el-button>
            <div v-if="form.award_cover!=''" class="img">
              <img :src="form.award_cover" width="100" height="100" />
            </div>
          </el-row>
          
        </el-form-item>

      </el-form>

    </div>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" @click="cancelFunc">取消</el-button>
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
    </div>
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    <!--商品选择-->
    <Product :isproduct="isproduct" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Product>
  </div>
</template>
<script>
import SweepstakesApi from '@/api/sweepstakes.js';
import Product from '@/components/product/Product.vue';
import Upload from '@/components/file/Upload';
export default {
  components: {
    Product,
    Upload
  },
  data() {
    return {
      isproduct:false,
      /*产品去重*/
      excludeIds: [],

      isupload:false,
      form: {
        awards_id:'',
        title:'',
        award_cover:'',
        weight:0,
        is_point: false,
        point: 0,
        is_product:false,
        product_id:0,
        is_image:false,
        image_id:0,
        file_path:'',
        product_num:0,
        product_sku_id:0,
        sweepstakes_id:0,
      },
      /*判断是否正在加载*/
      loading: false,


    };
  },
  created() {
    this.form.awards_id = this.$route.query.awards_id;
    this.getData();
  },
  methods: {
    /*获取编辑数据*/
    getData() {
      let self = this;
      self.loading = true;
      SweepstakesApi.editSweepstakesAwards({
        awards_id: self.form.awards_id
      }, true )
        .then(res => {
          self.form = res.data.model;

          self.loading = false;

        })
        .catch(error => {
          self.loading = false;
        });
    },
    addRewardProduct(e){
      this.isproduct = true;

    },
    /*关闭弹窗*/
    closeDialogFunc(e) {
      let self = this;
      self.isproduct = false;
      if (e.type == 'success') {

        this.form.product_id = e.params.product_id;

      }
    },
    /*上传*/
    openUpload(type) {
      this.img_type = type;
      this.isupload = true;

    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {

          if(this.img_type=='image'){
            this.form.image_id = e[0].file_id;
             this.form.file_path = e[0].file_path;
          }else{
            this.form.award_cover = e[0].file_path;
          }

      }
      this.isupload = false;
     },


    /*提交表单*/
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {

          let params = self.form;

          self.loading = true;
          SweepstakesApi.saveSweepstakesAwards(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，添加成功',
                type: 'success'
              });
              self.$router.push({path: '/plus/sweepstakes/index',
                query: {
                  type: 'sweepstakesawards',
                  sweepstakes_id: this.form.sweepstakes_id
                }});
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/sweepstakes/sweepstakesawards/edit.vue